/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { ShipmentDtoModel } from '@well/delivery-libs/shipment/domain';

export class OrderValidatorUtils {

  public static equalCustomValuesValidator(formGroup: AbstractControl): ValidationErrors | null {

    if (!(formGroup instanceof FormGroup)) {
      return null;
    }

    const error = {};
    if (!formGroup || !formGroup.value) {
      return {
        notEqualCustomDuties: true,
        notEqualCustomRegimes: true
      };
    }
    const shipments: ShipmentDtoModel[] = formGroup.value.shipments;
    if (!shipments || shipments.length <= 1) {
      return null;
    }
    const customDuties = [];
    const customRegimes = [];
    for (const shipment of shipments) {
      customDuties.push(shipment.customsDuty || false);
      customRegimes.push(shipment.customsRegime || false);
    }
    if (!OrderValidatorUtils.allArrayElementAreEqual(customDuties)) {
      Object.assign(error, {notEqualCustomDuties: true});
    }
    if (!OrderValidatorUtils.allArrayElementAreEqual(customRegimes)) {
      Object.assign(error, {notEqualCustomRegimes: true});
    }
    if (Object.keys(error).length > 0) {
      return error;
    }
    return null;
  }

  private static allArrayElementAreEqual(array: any[]) {
    return array.every((value, index, arr: any[]) => value === arr[0]);
  }
}
